<div class="flex flex-column h-full">
  <p-tabs [value]="activeTab()">
    <p-tablist>
      @for (item of items; track item.routerLink) {
        <p-tab [value]="item.routerLink" [routerLink]="item.routerLink">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </p-tab>
      }
    </p-tablist>
  </p-tabs>
  <div class="flex-1 w-full py-3 flex align-items-center justify-content-center">
    <router-outlet />
  </div>
</div>
